function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "XRP_svg__clip-path",
  transform: "translate(-23 -23)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M23 23h704v704H23z"
})), /*#__PURE__*/React.createElement("style", null, ".XRP_svg__cls-4{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#XRP_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M375 727a352 352 0 10-248.9-103.1A352 352 0 00375 727z",
  transform: "translate(-23 -23)",
  fill: "#23292f"
}), /*#__PURE__*/React.createElement("path", {
  className: "XRP_svg__cls-4",
  d: "M503.79 225.09h52.93L446.66 334.9a102 102 0 01-144.2 0L192.71 225.09h52.87l83.6 83.41a64.62 64.62 0 0091.33 0zM245.33 530.51h-52.62L303.15 420a102 102 0 01144.2 0L558 530.51h-52.82L421 446.41a64.62 64.62 0 00-91.33 0z",
  transform: "translate(-23 -23)"
}));

function SvgXrp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "XRP_svg__Layer_1",
    "data-name": "Layer 1",
    width: 24,
    height: 25,
    viewBox: "0 0 704 704"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "291601ad024fa012539b82eadc3c0538.svg";
export { SvgXrp as ReactComponent };